import React from "react";
import { viewPDF } from "../../../utils/viewPDF";
import { Box, Button, Grid2, Typography } from "@mui/material";

const AdvanceDetails = ({ tender, workItems, storedUser, tableRef }) => {
  const groupedWorkItems = workItems?.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };
  return (
    <div>
      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">1. Tender Details</Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Tender ID
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000", borderRight: "1px solid #000" }}
          >
            {tender && tender.tenderId}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Title
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.title}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Short Description
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.shortDesc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Long Description
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.longDesc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Tender Purchase Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDate(tender.tenderPurchaseDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Tender Publish Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDate(tender.tenderPublishDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Submission Start Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidSubmissionStartDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Submission End Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidSubmissionEndDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Opening Date
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && formatDateTime(tender.bidOpeningDate)}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bid Offer Validity (From End Date) (In Days)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.bidOfferValidity}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Department Name
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.deptName}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Contact Person Email
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.contactEmail}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Item Category
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.itemCategory}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Contract Period (In Months)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.contractPeriod}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Documents required from seller
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.sellerDoc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Type of Tender
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.type}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Time allowed for Technical Clarifications (in days)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.technicalExpiry}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Estimated Bid Value (in &#8377;)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.bidValue !== undefined
              ? new Intl.NumberFormat("en-IN", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(tender.bidValue)
              : "-"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Evaluation Method
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.evalMethod}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Arbitration Clause
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.arbitrationClause ? "Yes" : "No"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Mediation Clause
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.mediationClause ? "Yes" : "No"}
          </Grid2>
        </Grid2>

        <Typography className="form-title">2. EMD Details</Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Advisory Bank
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.emdBank}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            EMD Amount (in &#8377;)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.emdAmount !== undefined
              ? new Intl.NumberFormat("en-IN", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(tender.emdAmount)
              : "-"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Bank Account Number
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.accountNumber}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            IFSC
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.ifsc}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Beneficiary Name
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.accountName}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Account Type
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.accountType}
          </Grid2>
        </Grid2>

        <Typography className="form-title">3. ePBG Details</Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Advisory Bank
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.pbgBank}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            ePBG Percentage
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.pbgPercentage && `${tender.pbgPercentage}%`}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Duration of ePBG required (Months)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.pbgDuration}
          </Grid2>
        </Grid2>

        <Typography className="form-title">
          4. Additional Qualification/Data Required
        </Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Annual Turnover (in &#8377;)
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.annualTurnover !== undefined
              ? new Intl.NumberFormat("en-IN", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(tender.annualTurnover)
              : "-"}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Total Number of years of experience
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.expYears}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Experience of similar work
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.expSimilarWork}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Number of Employees
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000" }}
          >
            {tender && tender.totalEmp}
          </Grid2>
        </Grid2>

        <Typography className="form-title">
          5. Technical Specifications
        </Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            TS-1 {tender && tender.ts1Title && <span>({tender.ts1Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              padding: "10px 7px",
            }}
          >
            {tender && tender.ts1 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts1, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-2 {tender && tender.ts2Title && <span>({tender.ts2Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts2 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts2, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-3 {tender && tender.ts3Title && <span>({tender.ts3Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts3 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts3, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-4 {tender && tender.ts4Title && <span>({tender.ts4Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts4 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts4, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-5 {tender && tender.ts5Title && <span>({tender.ts5Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts5 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts5, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-6 {tender && tender.ts6Title && <span>({tender.ts6Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts6 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts6, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-7 {tender && tender.ts7Title && <span>({tender.ts7Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts7 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts7, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            TS-8 {tender && tender.ts8Title && <span>({tender.ts8Title})</span>}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.ts8 && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts8, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
        </Grid2>

        <Typography className="form-title">
          6. Buyer Added Bid Specific Terms and Conditions
        </Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Buyer Added text based clauses
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            {tender && tender.buyerTNC}
          </Grid2>
        </Grid2>

        <Typography className="form-title">
          7. General Terms and Conditions
        </Typography>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderTop: "1px solid #000" }}
          >
            Terms and conditions
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              padding: "10px 7px",
            }}
          >
            {tender && tender.tnc && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.tnc, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Service Level Agreement
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.serviceAgreement && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.serviceAgreement, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
            Safety and Environment Protection
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            className="preview-grid"
            sx={{ borderRight: "1px solid #000", padding: "10px 7px" }}
          >
            {tender && tender.protection && (
              <Button
                sx={{
                  margin: "0 !important",
                  padding: "0 !important",
                  width: "auto !important",
                  fontSize: "14px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.protection, storedUser)}
              >
                View
              </Button>
            )}
          </Grid2>
        </Grid2>
      </Box>

      <h2>Work Items Details</h2>
      <Box className="dashboard-container" px={10}>
        <table
          className="work-items"
          id="work-items"
          ref={tableRef}
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "20px" }}>Item Name</th>
              <th>Description</th>
              <th>Section</th>
              <th>Unit</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {groupedWorkItems &&
              Object.entries(groupedWorkItems).map(
                ([section, items], sectionIndex) => (
                  <React.Fragment key={sectionIndex}>
                    <tr
                      style={{
                        backgroundColor: "#d8e9f0",
                        fontWeight: "bold",
                      }}
                    >
                      <td
                        colSpan={5}
                        style={{ textAlign: "left", padding: "10px" }}
                      >
                        {section}
                      </td>
                    </tr>
                    {items
                      .sort((a, b) => a.itemOrder - b.itemOrder)
                      .map((item, index) => (
                        <tr key={index} style={{ textAlign: "center" }}>
                          <td style={{ padding: "20px" }}>{item.itemName}</td>
                          <td>{item.description}</td>
                          <td>{item.section}</td>
                          <td>{item.unit}</td>
                          <td>{item.quantity}</td>
                        </tr>
                      ))}
                  </React.Fragment>
                )
              )}
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default AdvanceDetails;
